module.exports = __webpack_public_path__ + "img/banner-企业微信.b99dd2a1.svg";